export function normalizeAssignmentCompanyKey(value) {
  const normalizedValue = String(value || "").trim().toLowerCase();
  return normalizedValue || "";
}

function pickCanonicalCompanyName(row) {
  return [row?.cbName, row?.gdName, row?.companyHouseName]
    .map((value) => String(value || "").trim())
    .find(Boolean);
}

function pushUniqueName(target, value) {
  const normalizedValue = String(value || "").trim();
  if (!normalizedValue || target.includes(normalizedValue)) {
    return;
  }

  target.push(normalizedValue);
}

export function buildAssignmentCanonicalNameLookup(rows) {
  return (rows || []).reduce((lookup, row) => {
    const canonicalName = pickCanonicalCompanyName(row);
    if (!canonicalName) {
      return lookup;
    }

    [row?.cbName, row?.gdName, row?.companyHouseName]
      .map((value) => String(value || "").trim())
      .filter(Boolean)
      .forEach((name) => {
        lookup[normalizeAssignmentCompanyKey(name)] = canonicalName;
      });

    return lookup;
  }, {});
}

export function resolveCanonicalAssignmentCompanyName(companyName, canonicalNameLookup) {
  const trimmedCompanyName = String(companyName || "").trim();
  if (!trimmedCompanyName) {
    return "";
  }

  const normalizedKey = normalizeAssignmentCompanyKey(trimmedCompanyName);
  return canonicalNameLookup?.[normalizedKey] || trimmedCompanyName;
}

export function buildAssignmentDatasetNameLookup(rows) {
  return (rows || []).reduce((lookup, row) => {
    const canonicalName = pickCanonicalCompanyName(row);
    if (!canonicalName) {
      return lookup;
    }

    const canonicalKey = normalizeAssignmentCompanyKey(canonicalName);
    if (!lookup[canonicalKey]) {
      lookup[canonicalKey] = {
        crunchbaseNames: [],
        globaldataNames: [],
        companyHouseNames: [],
      };
    }

    pushUniqueName(lookup[canonicalKey].crunchbaseNames, row?.cbName);
    pushUniqueName(lookup[canonicalKey].globaldataNames, row?.gdName);
    pushUniqueName(lookup[canonicalKey].companyHouseNames, row?.companyHouseName);

    return lookup;
  }, {});
}

export function resolveAssignmentNamesForDataset(
  canonicalCompanyName,
  datasetNameLookup,
  dataset
) {
  const trimmedCanonicalName = String(canonicalCompanyName || "").trim();
  if (!trimmedCanonicalName) {
    return [];
  }

  const canonicalKey = normalizeAssignmentCompanyKey(trimmedCanonicalName);
  const entry = datasetNameLookup?.[canonicalKey];

  const names =
    dataset === "globaldata"
      ? entry?.globaldataNames
      : dataset === "companyhouse"
      ? entry?.companyHouseNames
      : entry?.crunchbaseNames;

  if (Array.isArray(names) && names.length > 0) {
    return names;
  }

  return [trimmedCanonicalName];
}
